export class PostsModel {  
    public id: string
    public date: Date
    public title: string
    public subtitle: string
    public image: string 
    public text: string 
}